import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overrideSection", "providerFields", "providerType", "nameField"]

  toggleOverride(event) {
    this.overrideSectionTarget.hidden = !event.target.checked
  }

  switchProvider(event) {
    const providerKey = event.target.value
    this.providerFieldsTargets.forEach(function(el) {
      el.hidden = el.dataset.provider !== providerKey
    })
    this.providerTypeTarget.value = providerKey
  }

  toggleSaveToAccount(event) {
    this.nameFieldTarget.hidden = !event.target.checked
  }
}
